import React, { useEffect, useState } from 'react';
import axios from 'axios';
import styles from './Music.module.css';
import AlbumPage from './AlbumPage.js';
import AlbumAbout from './AlbumAbout.js';
import { API_ENDPOINT } from '../apiEndpoints.js';
import { Link } from 'react-router-dom';

const OriginalMusic = () => {
  const [albums, setAlbums] = useState([]);
  const [albumid, setAlbumid] = useState(null);
  const [hoveredAlbum, setHoveredAlbum] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [artist1Response, artist3Response] = await Promise.all([
          axios.get(`${API_ENDPOINT}/albums/artistid/1`),
          axios.get(`${API_ENDPOINT}/albums/artistid/3`)
        ]);
        setAlbums([...artist1Response.data, ...artist3Response.data]);
      } catch (error) {
        console.error("Error fetching albums:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleAlbumClick = (albumid) => {
    setAlbumid(albumid);
    setHoveredAlbum(null);
  };

  const handleAlbumHover = (albumid) => {
    setHoveredAlbum(albumid);
  };

  const handleAlbumLeave = () => {
    setHoveredAlbum(null);
  };

  const hardcodedAlbumIds = [ 229, 230, 241, 238 ];

  return (
    <div>
      <div className={styles.Music}>
        <div className={styles.albumList}>
          {hardcodedAlbumIds.map(hardcodedId => {
            const album = albums.find(a => a.id === hardcodedId);
            if (!album) return null;
            return (
              <div
                key={album.id}
                className={styles.horizontalAlbumCard}
                onMouseEnter={() => handleAlbumHover(album.id)}
                onMouseLeave={handleAlbumLeave}
                onClick={() => handleAlbumClick(album.id)}
              >
                <Link to={`/music/album/${album.id}`} style={{ textDecoration: 'none' }}>
                  <div className={styles.albums}>
                    <img
                      src={album.fileurl}
                      alt={album.albumname}
                      className={`${styles.albumListImg} ${hoveredAlbum === album.id ? styles.hoveredAlbum : ''}`}
                      onMouseEnter={() => handleAlbumHover(album.id)}
                      onMouseLeave={handleAlbumLeave}
                    />
                    <div className={styles.about}>
                      <AlbumAbout albumid={album.id} />
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}

          {/* Dreams of Venus — Bandcamp */}
          <div className={styles.horizontalAlbumCard}>
            <a
              href="https://vyvyv.bandcamp.com/album/dreams-of-venus"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none' }}
            >
              <div className={styles.albums}>
                <img
                  src="https://benjamincleek.s3.us-west-2.amazonaws.com/photos/3a69f916-2b5c-4f55-bec6-33a8fcdb81e3-vyvyv%20-%20what%20dreams%20may%20cme.png"
                  alt="Dreams of Venus by VYVYV"
                  className={styles.albumListImg}
                />
                <div className={styles.about}>
                  <div className={styles.albumName}>Dreams of Venus</div>
                  <div className={styles.description}>VYVYV</div>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div className={styles.player}>
          {albumid && <AlbumPage albumid={albumid} />}
        </div>
      </div>
    </div>
  );
};

export default OriginalMusic;
